import * as React from 'react'

type ChangeVisibilityCallback = (visibility: boolean) => void
const defaultCallback = (_visibility: boolean) => {}
export const ModalContext =
  React.createContext<ChangeVisibilityCallback>(defaultCallback)
